import React from "react"
import Page from "./Page"
function Testing(props) {
    return <Page title={props.title}>Testing</Page>
}

export default Testing
